import { useColorArea } from "@react-aria/color";
import {
  ColorAreaProps as AriaColorAreaProps,
  useColorAreaState,
} from "@react-stately/color";
import * as React from "react";
import { BorderRadius, SizeOption } from "../../utils/theme";
import { cx } from "../../utils/dom";
import { StyleProps } from "../../utils/types";
import { useFocusRing } from "react-aria";
import { useTheme } from "../theme";

type ColorAreaProps = AriaColorAreaProps &
  StyleProps<"wrapper" | "thumb"> & {
    size?: SizeOption;
    radius?: BorderRadius;
  };

export function ColorArea({
  className,
  classNames,
  style,
  styles,
  radius,
  ...props
}: ColorAreaProps) {
  const inputXRef = React.useRef(null);
  const inputYRef = React.useRef(null);
  const containerRef = React.useRef(null);

  const state = useColorAreaState(props);
  const { colorAreaProps, xInputProps, yInputProps, thumbProps } = useColorArea(
    { ...props, inputXRef, inputYRef, containerRef },
    state
  );

  const { focusProps, isFocusVisible } = useFocusRing();
  const theme = useTheme();

  return (
    <div
      {...colorAreaProps}
      ref={containerRef}
      style={{ ...colorAreaProps.style, ...styles?.wrapper, ...style }}
      className={cx("p-color-area", className, classNames?.wrapper)}
      data-disabled={props.isDisabled}
      data-radius={radius ?? theme?.radius ?? "lg"}
    >
      <div
        {...thumbProps}
        style={{ ...thumbProps.style, ...styles?.thumb }}
        className={cx("p-color-area-thumb", classNames?.thumb)}
        data-focus-visible={isFocusVisible}
        data-color={state.getDisplayColor().toString("css")}
      >
        <input {...xInputProps} ref={inputXRef} {...focusProps} />
        <input {...yInputProps} ref={inputYRef} {...focusProps} />
      </div>
    </div>
  );
}
